// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/fonts/codec-cold/Codec-Cold-Regular-trial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/fonts/codec-cold/Codec-Cold-News-trial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/fonts/codec-cold/Codec-Cold-Bold-trial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/fonts/Codec/Codec-Cold-Bold-trial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/fonts/codec-cold/Codec-Cold-ExtraBold-trial.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/fonts/Montserrat/static/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/fonts/Montserrat/static/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/fonts/Montserrat/static/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/assets/fonts/Readex_Pro/static/ReadexPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/assets/fonts/Roboto/static/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/assets/fonts/freesans/FreeSans.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../public/assets/fonts/freeserif/FreeSerifBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../public/assets/fonts/Inter/static/Inter_18pt-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../public/assets/fonts/Inter/static/Inter_18pt-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../public/assets/fonts/Inter/static/Inter_24pt-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../public/assets/fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../public/assets/fonts/times-new-roman/times.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import local fonts */
@font-face {
  font-family: 'Codec-Cold-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Codec-Cold-News';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Codec-Cold-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Codec-Cold-Bold-Trial';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}


@font-face {
  font-family: 'Codec-Cold-ExtraBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Montserrat-SemiBold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Montserrat-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Montserrat-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'ReadexPro-Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Roboto-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'freesans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}


@font-face {
  font-family: 'freeserif';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'inter_18pt-semibold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'inter_18pt-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'inter_18pt-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Poppins-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'times-new-roman';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

:root {
  --primary-color: #6218C5;
  --secondary-color: #F2CC00;

  --text-primary: #6218C5;
  --text-primary-light: hsl(265, 59%, 94%);
  --text-secondary: #0D0D0D;
  --text-gray: #656565;
  --text-gray-dark: #060606;
  --text-gray-light: #6A6464;
  --text-gray-light-2: #0A0A0A;

  --text-white: #FFFFFF;
  --text-black: #000000;
  --text-black-light: #070707;
  --text-black-light-2: #040404;
  --text-black-light-3: #0E0E0E;
  --text-black-light-4: #323232;
  --text-black-light-5: #080808;
  --text-black-light-6: #9F9F9F;

  --bg-white: #FFFFFF;
  --bg-black: #000000;

  --font-x-size-small: 12px;
  --font-size-small: 14px;
  --font-15: 15px;
  --font-size-xsmall: 16px;
  --font-size-18: 18px;
  --font-size-regular: 19px;
  --font-size-medium: 20px;
  --font-size-large: 24px;
  --font-size-25: 25px;
  --font-size-xlarge: 28px;
  --font-size-30: 30px;
  --font-size-xxlarge: 32px;
  --font-size-lg: 34px;
  --font-size-40: 40px;
  --font-size-xxxlarge: 45px;
  --font-size-xxxxlarge: 60px;

  --font-regular: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;
  --font-extrabold: 800;
  --font-black: 900;

  --font-codec-cold: 'Codec-Cold-Bold', sans-serif;
  --font-codec-cold-extra-bold: 'Codec-Cold-ExtraBold', sans-serif;
  --font-montserrat: 'Montserrat', sans-serif;
  --font-montserrat-semibold: 'Montserrat-SemiBold', sans-serif;
  --font-montserrat-medium: 'Montserrat-Medium', sans-serif;
  --font-montserrat-bold: 'Montserrat-Bold', sans-serif;
  --font-readex-pro-light: 'ReadexPro-Light', sans-serif;
  --font-roboto: 'Roboto-Regular', sans-serif;
  --font-freesans: 'freesans', sans-serif;
  --font-freeserif: 'freeserif', sans-serif;
  --font-inter-semibold: 'inter_18pt-semibold', sans-serif;
  --font-inter-medium: 'inter_18pt-Medium', sans-serif;
  --font-codec-cold-regular: 'Codec-Cold-Regular', sans-serif;
  --font-codec-cold-medium: 'Codec-Cold-News', sans-serif;
  --font-inter-regular: 'inter_18pt-Regular', sans-serif;
  --font-poppins: 'Poppins-Regular', sans-serif;
  --font-times-new-roman: 'times-new-roman', sans-serif;
  --primary-gradient: linear-gradient(90deg,
      #6400CD 0%,
      rgba(245, 158, 11, 0.65) 100%);
  --placeholder1: #bfbfbf;
  --input-color1: #000000;
  --input-height-44: 50px;
  --button-height-48: 46px;
}`, "",{"version":3,"sources":["webpack://./src/variables.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,+DAA6F;EAC7F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAA0F;EAC1F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAA0F;EAC1F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+DAAqF;EACrF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,mCAAmC;EACnC,+DAA+F;EAC/F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+DAA+F;EAC/F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+DAA6F;EAC7F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAA2F;EAC3F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAA2F;EAC3F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAAsF;EACtF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gEAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,gEAAiF;EACjF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gEAA0F;EAC1F,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gEAAwF;EACxF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gEAAyF;EACzF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gEAAiF;EACjF,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gEAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;;EAE1B,uBAAuB;EACvB,wCAAwC;EACxC,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;;EAE5B,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,mBAAmB;EACnB,mBAAmB;;EAEnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;;EAE3B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;;EAEjB,gDAAgD;EAChD,gEAAgE;EAChE,2CAA2C;EAC3C,6DAA6D;EAC7D,yDAAyD;EACzD,qDAAqD;EACrD,sDAAsD;EACtD,2CAA2C;EAC3C,uCAAuC;EACvC,yCAAyC;EACzC,wDAAwD;EACxD,oDAAoD;EACpD,2DAA2D;EAC3D,uDAAuD;EACvD,sDAAsD;EACtD,6CAA6C;EAC7C,qDAAqD;EACrD;;oCAEkC;EAClC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B","sourcesContent":["/* Import local fonts */\n@font-face {\n  font-family: 'Codec-Cold-Regular';\n  src: url('../public/assets/fonts/codec-cold/Codec-Cold-Regular-trial.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Codec-Cold-News';\n  src: url('../public/assets/fonts/codec-cold/Codec-Cold-News-trial.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Codec-Cold-Bold';\n  src: url('../public/assets/fonts/codec-cold/Codec-Cold-Bold-trial.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Codec-Cold-Bold-Trial';\n  src: url('../public/assets/fonts/Codec/Codec-Cold-Bold-trial.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n\n@font-face {\n  font-family: 'Codec-Cold-ExtraBold';\n  src: url('../public/assets/fonts/codec-cold/Codec-Cold-ExtraBold-trial.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Montserrat-SemiBold';\n  src: url('../public/assets/fonts/Montserrat/static/Montserrat-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Montserrat-Medium';\n  src: url('../public/assets/fonts/Montserrat/static/Montserrat-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Montserrat-Bold';\n  src: url('../public/assets/fonts/Montserrat/static/Montserrat-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'ReadexPro-Light';\n  src: url('../public/assets/fonts/Readex_Pro/static/ReadexPro-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Roboto-Regular';\n  src: url('../public/assets/fonts/Roboto/static/Roboto-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'freesans';\n  src: url('../public/assets/fonts/freesans/FreeSans.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n\n@font-face {\n  font-family: 'freeserif';\n  src: url('../public/assets/fonts/freeserif/FreeSerifBold.otf') format('opentype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'inter_18pt-semibold';\n  src: url('../public/assets/fonts/Inter/static/Inter_18pt-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'inter_18pt-Medium';\n  src: url('../public/assets/fonts/Inter/static/Inter_18pt-Medium.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'inter_18pt-Regular';\n  src: url('../public/assets/fonts/Inter/static/Inter_24pt-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Poppins-Regular';\n  src: url('../public/assets/fonts/Poppins/Poppins-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'times-new-roman';\n  src: url('../public/assets/fonts/times-new-roman/times.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  --primary-color: #6218C5;\n  --secondary-color: #F2CC00;\n\n  --text-primary: #6218C5;\n  --text-primary-light: hsl(265, 59%, 94%);\n  --text-secondary: #0D0D0D;\n  --text-gray: #656565;\n  --text-gray-dark: #060606;\n  --text-gray-light: #6A6464;\n  --text-gray-light-2: #0A0A0A;\n\n  --text-white: #FFFFFF;\n  --text-black: #000000;\n  --text-black-light: #070707;\n  --text-black-light-2: #040404;\n  --text-black-light-3: #0E0E0E;\n  --text-black-light-4: #323232;\n  --text-black-light-5: #080808;\n  --text-black-light-6: #9F9F9F;\n\n  --bg-white: #FFFFFF;\n  --bg-black: #000000;\n\n  --font-x-size-small: 12px;\n  --font-size-small: 14px;\n  --font-15: 15px;\n  --font-size-xsmall: 16px;\n  --font-size-18: 18px;\n  --font-size-regular: 19px;\n  --font-size-medium: 20px;\n  --font-size-large: 24px;\n  --font-size-25: 25px;\n  --font-size-xlarge: 28px;\n  --font-size-30: 30px;\n  --font-size-xxlarge: 32px;\n  --font-size-lg: 34px;\n  --font-size-40: 40px;\n  --font-size-xxxlarge: 45px;\n  --font-size-xxxxlarge: 60px;\n\n  --font-regular: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  --font-bold: 700;\n  --font-extrabold: 800;\n  --font-black: 900;\n\n  --font-codec-cold: 'Codec-Cold-Bold', sans-serif;\n  --font-codec-cold-extra-bold: 'Codec-Cold-ExtraBold', sans-serif;\n  --font-montserrat: 'Montserrat', sans-serif;\n  --font-montserrat-semibold: 'Montserrat-SemiBold', sans-serif;\n  --font-montserrat-medium: 'Montserrat-Medium', sans-serif;\n  --font-montserrat-bold: 'Montserrat-Bold', sans-serif;\n  --font-readex-pro-light: 'ReadexPro-Light', sans-serif;\n  --font-roboto: 'Roboto-Regular', sans-serif;\n  --font-freesans: 'freesans', sans-serif;\n  --font-freeserif: 'freeserif', sans-serif;\n  --font-inter-semibold: 'inter_18pt-semibold', sans-serif;\n  --font-inter-medium: 'inter_18pt-Medium', sans-serif;\n  --font-codec-cold-regular: 'Codec-Cold-Regular', sans-serif;\n  --font-codec-cold-medium: 'Codec-Cold-News', sans-serif;\n  --font-inter-regular: 'inter_18pt-Regular', sans-serif;\n  --font-poppins: 'Poppins-Regular', sans-serif;\n  --font-times-new-roman: 'times-new-roman', sans-serif;\n  --primary-gradient: linear-gradient(90deg,\n      #6400CD 0%,\n      rgba(245, 158, 11, 0.65) 100%);\n  --placeholder1: #bfbfbf;\n  --input-color1: #000000;\n  --input-height-44: 50px;\n  --button-height-48: 46px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
